"use strict";
var DocumentCardType;
(function (DocumentCardType) {
    /**
     * Standard DocumentCard.
     */
    DocumentCardType[DocumentCardType["normal"] = 0] = "normal";
    /**
     * Compact layout. Displays the preview beside the details, rather than above.
     */
    DocumentCardType[DocumentCardType["compact"] = 1] = "compact";
})(DocumentCardType = exports.DocumentCardType || (exports.DocumentCardType = {}));

//# sourceMappingURL=DocumentCard.Props.js.map



//////////////////
// WEBPACK FOOTER
// ../components/DocumentCard/DocumentCard.Props.js
// module id = 177
// module chunks = 0